document.addEventListener("turbo:load", function () {
  const bottomBarElm = document.querySelector("#bottom-bar");

  if (bottomBarElm) {
    const observeStartElm = bottomBarElm.dataset.start ? document.querySelector(bottomBarElm.dataset.start) : null;
    const observeStopElm = bottomBarElm.dataset.stop ? document.querySelector(bottomBarElm.dataset.stop) : null;
    const footerElm = document.querySelector("footer");
    let stopPassed = false;

    // If no start element is specified, show the bar always
    if (!observeStartElm) {
      bottomBarElm.classList.add("show");
      return;
    }

    const handleNavbarVisibility = (entries, observer) => {
      entries.forEach(entry => {
        // if (entry.target.isEqualNode(observeStopElm)) {
        //   if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
        //     stopPassed = true;
        //   } else {
        //     stopPassed = false;
        //   }
        // }

        if (entry.isIntersecting || document.documentElement.scrollTop <= 60) {
          bottomBarElm.classList.remove("show");
        } else if (!stopPassed) {
          bottomBarElm.classList.add("show");
        }
      })
    }

    // const options = {
    //   root: null,
    //   rootMargin: '0px',
    //   threshold: 0.1 // Adjust if needed
    // };

    const observer = new IntersectionObserver(handleNavbarVisibility);

    if (observeStopElm) { observer.observe(observeStopElm) };
    observer.observe(observeStartElm);
    if (footerElm) { observer.observe(footerElm) };
  }
});
